var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stepwise-progress"},[_c('ul',_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,class:{
        completed: index < _vm.currentStepIdx,
        active: index === _vm.currentStepIdx,
        incomplete: index > _vm.currentStepIdx,
      }},[_c('span',{staticClass:"position-indicator"},[_vm._v(_vm._s(index + 1))]),_c('span',[_vm._v(_vm._s(step.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }